<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" v-bind:style="{ width: width }" @click.stop>
          <button class="modal-default-button" @click="closeModal" id="modal3">
            X
          </button>
          <div class="modal-header">
            <h3>{{ title }}</h3>
          </div>
          <div class="modal-body">
            <component :is="component" :data="data" v-on:close="closeModal"></component>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import ConfirmReplace from '../GeneralViews/Modal/ConfirmReplace'
  import Constants from 'src/utilities/constants'
  import EditJob from '../Dashboard/Views/Jobs/Modal/EditJob'
  import EditTask from '../Dashboard/Views/Tasks/Modal/EditTask'
  import LegalSubdivision from '../Dashboard/Views/LegalSubdivisions/Modal/LegalSubdivision'
  import ModifyTaskDueDates from '../Dashboard/Views/Tasks/Modal/ModifyTaskDueDates'
  import NoLegalSubdivisionResultsFound from '../Dashboard/Views/LegalSubdivisions/Modal/NoResultsFound'
  import NoPlanNameResultsFound from '../Dashboard/Views/PlanNames/Modal/NoResultsFound'
  import PlanName from '../Dashboard/Views/PlanNames/Modal/PlanName'
  import ProjectNotes from '../Dashboard/Views/Projects/Modal/ProjectNotes.vue'
  import ViewJob from '../Dashboard/Views/Jobs/Modal/ViewJob'
  import {focusTrap} from '@/utilities/utils'

  export default {
    props: ['title', 'component', 'data', 'width'],
    components: {
      ConfirmReplace,
      EditJob,
      EditTask,
      LegalSubdivision,
      ModifyTaskDueDates,
      NoLegalSubdivisionResultsFound,
      NoPlanNameResultsFound,
      PlanName,
      ProjectNotes,
      ViewJob
    },
    methods: {
      closeModal () {
        this.$emit('close')
      }
    },
    mounted() {
      document.addEventListener('keydown', (e) => {
        if (e.keyCode === Constants.ESCAPE_KEY) {
          this.$emit('close')
        }
      })
      focusTrap('modal3', this.component)
      this.$store.set('modalTracker/modal3', this.component)
    },
    destroyed() {
      this.$store.set('modalTracker/modal3', null)
    },
    watch: {
      'component': {
        handler: function () {
          this.$store.set('modalTracker/modal3', this.component)
        }
      }
    }
  }
</script>
<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 2000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    z-index: 2001;
  }

  .modal-container {
    width: 74%;
    max-height: calc(100vh - 50px);
    max-width: calc(100vw - 50px);
    margin: 0 auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    z-index: 999;
  }

  .modal-header, .modal-footer {
    border: none;
    padding: 0;
  }
  .modal-header h3 {
    margin: 0;
    padding: 0;
  }

  .modal-body {
    padding: 0;
    margin: 10px 0;
  }

  .modal-default-button {
    float: right;
    z-index: 100000;
  }

  /*
   * The following styles are auto-applied to elements with
   * transition="Modal" when their visibility is toggled
   * by Vue.js.
   *
   * You can easily play with the Modal transition by editing
   * these styles.
   */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
</style>
